// import dayjs from 'dayjs'
// import utc from 'dayjs/plugin/utc'
import { customUTCString } from '~/utils/deviceInfo'
// dayjs.extend(utc)
export default {
  middleware({ store, redirect, req, res, $config, route }) {
    try {
      const {
        banner_id: bannerUuid,
        banner_player_type: bannerPlayerType,
        'banner-origin-url': origin,
        banner_click_id: bannerClickId
      } = store.app.context.query

      const urlRegex = /^(https?):\/\/[^\s/$.?#].[^\s]*$/i
      const uuidRegex = /^[0-9a-f]{8}-[0-9a-f]{4}-4[0-9a-f]{3}-[0-9a-f]{4}-[0-9a-f]{12}$/i
      const playerTypeRegex = /^[1234567890]$/
      const mongoRegex = /^[a-f\d]{24}$/

      if (bannerUuid && bannerPlayerType) {
        const cookies = []
        const expireDate = new Date()
        expireDate.setDate(expireDate.getDate() + 10) // Set expiration to 10 days from now
        const expires = `Expires=${expireDate.toUTCString()};`
        const utcTime = customUTCString()

        if (urlRegex.test(origin)) {
          cookies.push(`x-banner-url=${origin};PATH=/;${expires}`)
        }
        if (uuidRegex.test(bannerUuid) && playerTypeRegex.test(bannerPlayerType)) {
          cookies.push(`x-direct-banner-id=${bannerUuid};PATH=/;${expires}`)
          cookies.push(
            `x-direct-banner-id-${bannerUuid}=${bannerUuid}|${utcTime};PATH=/;${expires}`
          )
          if (bannerPlayerType) {
            cookies.push(`x-player-type=${bannerPlayerType};PATH=/;${expires}`)
          }
        }
        if (mongoRegex.test(bannerClickId)) {
          cookies.push(`x-click-id=${bannerClickId};PATH=/;${expires}`)
        }
        res.setHeader('Set-Cookie', cookies)

        const cleanUrl = route.path

        return redirect(cleanUrl)
      }
    } catch (error) {}
  }
}
